import { render, staticRenderFns } from "./phone-field.vue?vue&type=template&id=23ccebe6"
import script from "./phone-field.vue?vue&type=script&lang=ts"
export * from "./phone-field.vue?vue&type=script&lang=ts"
import style0 from "./phone-field.vue?vue&type=style&index=0&id=23ccebe6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports